import Link from '@tiptap/extension-link';
import { LINK } from '../marks';
import { autolink } from './link/autolink';
import { linkids } from './link/linkids';
import { getLinkId, LinkAttrs, TrLinkOptions } from './link/util';

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		trLink: {
			/**
			 * Set a link mark
			 */
			setLink: (attributes: LinkAttrs) => ReturnType;
			/**
			 * Toggle a link mark
			 */
			toggleLink: (attributes: LinkAttrs) => ReturnType;
			/**
			 * Unset a link mark
			 */
			unsetLink: () => ReturnType;
		};
	}
}

export const TrLink = Link.extend<TrLinkOptions>({
	name: LINK,
	addAttributes() {
		return {
			...this.parent?.(),
			id: {
				default: null,
				parseHTML: (el: HTMLElement) => el.getAttribute('id') || getLinkId(),
			},
		};
	},
	parseHTML() {
		return [
			{
				tag: 'a[href]:not([href *= "javascript:" i])',
				getAttrs: (el) => {
					if (typeof el === 'string') {
						return { id: getLinkId() };
					}
					return { id: el.getAttribute('id') || getLinkId() };
				},
			},
		];
	},
	addProseMirrorPlugins() {
		const plugins = this.parent?.() || [];

		if (this.options.trAutolink) {
			plugins.push(autolink({
				type: this.type,
				validate: this.options.validate,
			}));
		}

		plugins.push(linkids({ type: this.type }));

		return plugins;
	},
});
